import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { ControllerConnection } from "../connection/controllerConnection"
import * as d3 from "d3";

class DecorationCurrent extends DecorationModel {
    constructor() {
        super("DecorationCurrent");
        this.node = null
        this.transientConnection = null;
        this.ctrConnection = new ControllerConnection()

        this.init = async function(newNode, openDialog) {
            let svg = SingletonFlowchart.svg;
            this.node = newNode;
            this.dialog = openDialog
            

            await svg
                .data([newNode])
                .append("g")
                .style("cursor", "pointer")
                .attr("id", `${newNode.idName}`)
                .append('text')
                .classed('title', true)
                .text(newNode.title)
                .attr("x", (d) => d.x)
                .attr("y", (d) => d.y)
                .style("font-weight", 550)
                .on('dblclick', () => openDialog(newNode))
                .call(this.setDrag(newNode))


            let g = d3.select(`#${newNode.idName}`)
            d3.selectAll(`#${newNode.idName} > text.current-attr`).remove();

            await newNode.data.forEach(n => {
                newNode.height += 20;

                g.append('text')
                    .attr("id", `${n.id}`)
                    .classed("current-attr", true)
                    .attr("x", n.x(newNode.x))
                    .attr("y", n.y(newNode.y))
                    .text(n.text())
                    .on('dblclick', () => openDialog(newNode))
                    .call(this.setDrag(newNode))

            })

            return svg;
        };

        this.setDrag = function() {
            if (this.node.readOnly)
                return d3.drag();

            let that = this;
            let drag = d3
                .drag()
                .on("start", that.dragstarted)
                .on("drag", (event, d) => that.dragged(event, d))
                .on("end", that.dragended);
            return drag;
        };

        this.dragstarted = function(event, d) {
            SingletonFlowchart.selectNode(`#${d.idName}`);

            d3.select(this).style("cursor", "grabbing");
        };

        this.dragged = async function(event, d) {
            SingletonFlowchart.clicked = false;

            d.x = event.x;
            d.y = event.y;

            this.move()
        };

        this.move = async() => {
            let d = this.node;

            d3.select(`#${d.idName} > .title`)
                .raise().attr("x", d.x)
                .attr("y", d.y);

            await d.data.forEach(n =>
                d3.select(`#${n.id}`)
                .raise()
                .attr("x", n.x(d.x))
                .attr("y", n.y(d.y))
            )
        }

        this.dragended = function() {
            d3.select(this).style("cursor", "pointer");
            SingletonFlowchart.SaveStatus();
        };

        this.setTextAndAdjustWidth = () => {
            let d = this.node;

            d3.select(`#${d.idName} > text.title`)
                .text(d.title)
                .node()

            d3.selectAll(`#${d.idName} > text.current-attr`).remove()
            d.data.forEach(n => {
                let g = d3.select(`#${d.idName}`)
                g.append('text')
                    .attr("id", n.id)
                    .classed("current-attr", true)
                    .attr("x", n.x(d.x))
                    .attr("y", n.y(d.y))
                    .text(n.text())
                    .on('dblclick', () => this.dialog(d))
                    .call(this.setDrag(d))
            })
        }
    }
}

export { DecorationCurrent };